import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Switch } from 'components/atoms/switch/switch';
import { ConfigItems } from './styles';

interface Props {
  switches: {
    publish: {
      setPublished: (val: boolean) => void;
      isPublished: boolean;
    };
    private: {
      setPrivate: (val: boolean) => void;
      isPrivate: boolean;
    };
  };
}

export const ConfigSwitches = ({
  switches: {
    publish: { setPublished, isPublished },
    private: { setPrivate, isPrivate },
  },
}: Props): React.ReactElement => {
  const onPublishChange = (checked) => {
    setPublished(checked);
  };

  return (
    <>
      <ConfigItems>
        <ConfigItems>
          <Switch
            size="small"
            checked={isPublished}
            onChange={onPublishChange}
          />
          <FormattedMessage id="templates.status_updates.tab.config.publish" />
        </ConfigItems>
        <ConfigItems>
          <Switch size="small" checked={isPrivate} onChange={setPrivate} />
          <FormattedMessage id="templates.status_updates.tab.config.private" />
        </ConfigItems>
      </ConfigItems>
    </>
  );
};
